// ─── logAccess ──────────────────────────────────────────────────────────────
// Registra un evento de acceso en la tabla access_log. Se llama en dos sitios:
//   1. Al iniciar sesión / cargar la app (section='app').
//   2. Al cambiar de sección de proyecto dentro de la app (section='pliego', ...).
//
// El log es best-effort · si falla no bloquea la navegación (solo se pinta un
// warning en consola para que Gisell pueda depurar si algo va mal).
//
// La RLS garantiza que cada usuario solo puede insertar filas con su propio
// user_id, así que un usuario malintencionado no puede falsear accesos ajenos.
import { supabase } from './supabase'

export async function logAccess({ section, rama = null, projectId = null } = {}) {
  try {
    const { data: userData } = await supabase.auth.getUser()
    const userId = userData?.user?.id
    if (!userId) return  // no autenticado, nada que registrar
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent.slice(0, 200) : null
    await supabase.from('access_log').insert({
      user_id: userId,
      project_id: projectId,
      section,
      rama,
      user_agent: ua,
    })
  } catch (e) {
    console.warn('logAccess falló (no bloquea):', e?.message || e)
  }
}
